import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TableType } from '@soposopo/sopo-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/core/backend/api.service';

@Component({
    selector: 'table-countdown',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: "{{counterObservable$ | async}}",
    styleUrls: ['./table-countdown.component.scss'],
    standalone: false
})
export class TableCountdownComponent implements OnInit {
    @Input() dateFrom: number;
    @Input() type: TableType;
    counterObservable$: Observable<string>;

    constructor(
        private apiService: ApiService,

    ) { }

    ngOnInit() {
        this.setCounterObservable();
    }
    setCounterObservable() {
        this.counterObservable$ = this.apiService.getServerTimeObservable().pipe(
            map((serverTime) => {
                let count: number = 0;
                if (this.type === TableType.MTT) {
                    count = this.dateFrom - serverTime;
                } else {
                    count = this.dateFrom + 18000 - serverTime;
                }
                const days = Math.floor(count / 86400);
                const hours = Math.floor(count / 3600) % 24;
                const minCount = count - hours * 3600;
                const minutes = Math.floor(minCount / 60) % 60;
                const secCount = minCount - minutes * 60;
                const seconds = Math.floor(secCount % 60);
                if (days > 0) {
                    if (days == 1) return "in " + days + " day"
                    return "in " + days + " days"
                }
                if (count > 0) {
                    const hrs = ('0' + hours).slice(-2);
                    const min = ('0' + minutes).slice(-2);
                    const sec = ('0' + seconds).slice(-2);
                    return hrs + ':' + min + ':' + sec;
                }
                return "00:00:00";
            }
        ))
    }
}